module.exports = __webpack_public_path__ + "img/image-thumb-20.f9f6e5ee.webp";